module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/j24gbJ/tc-custom/9781488001604.jpg?1695265570022",
      "alt": "This image is the cover for the book Rancher's Marriage Pact, Texas Extreme"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rancher's Marriage Pact, Texas Extreme\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this sexy romance, a billionaire cowboy hires himself a convenient bride to meet the terms of his inheritance ,only to fall for his wife in-name-only.")]), _c('br'), _c('br'), _vm._v("Dallas Calloway is desperate to find a bride. If the billionaire former rodeo champ’s not married by his birthday, his dreams for the D Bar C will end, thanks to his father’s will. So Paris Reynolds’s arrival at the ranch looks like the answer to his prayers. "), _c('br'), _c('br'), _vm._v("The ravishing interior designer is desperate for a job. And Dallas has a proposition he hopes she can’t refuse—marry him for one year, in name only, then get an annulment. But with the irresistible passion raging between them, how will they ever make it a year without sharing a marriage bed?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kristi Gold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Since her first venture into novel writing in the mid-nineties, Kristi Gold has greatly enjoyed weaving stories of love and commitment. She's an avid fan of baseball, beaches and bridal reality shows.  During her career, Kristi has been a National Readers Choice winner, Romantic Times award winner, and a three-time Romance Writers of America RITA finalist.  She resides in Central Texas and can be reached through her website at http://kristigold.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0